
import { createSlice } from "@reduxjs/toolkit";

let initialCurrentFinancialStatementJourney = {}
const currentFinancialStatementJourneySlice = createSlice({
    name: 'currentcurrentFinancialStatementJourney',
    initialState: initialCurrentFinancialStatementJourney,
    reducers: {
        setCurrentFinancialStatementJourney: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetCurrentFinancialStatementJourney: () => {
            return initialCurrentFinancialStatementJourney
        }
    },
});

export const { setCurrentFinancialStatementJourney, resetCurrentFinancialStatementJourney } = currentFinancialStatementJourneySlice.actions;
export default currentFinancialStatementJourneySlice.reducer;